/* eslint-disable import/no-anonymous-default-export */
export default {
  "error.message.user_does_not_exist": "Benutzer existiert nicht",
  "error.message.username_not_found": "E-Mail nicht gefunden",
  "error.message.wrong_password": "Falsches Passwort",
  "error.message.user_inactive": "Inaktiver Benutzer",
  "error.message.missing_params": "Ungültige Parameter, bitte überprüfen!",
  "error.message.user_trial_time_expired":
    "Testzeit des Benutzers ist abgelaufen",
  "error.message.integration_already_exists":
    "Eine Integration zwischen diesen Projekten existiert bereits",
  "error.message.integration_project_from_the_same_company":
    "Integration von Projekten derselben Firma",
  "error.message.project_already_exists":
    "Ein Projekt mit diesem Namen existiert bereits",
  "error.message.projectTemplate_already_exists":
    "Eine Projektvorlage mit diesem Namen existiert bereits",
  "error.message.speciality_already_exists":
    "Eine Spezialität mit diesem Namen existiert bereits",
  "error.message.tenant_trial_time_expired":
    "Testzeit der Firma ist abgelaufen",
  "error.message.download_not_available": "Download nicht verfügbar",
  "error.message.folder_not_created":
    "Ein Fehler trat beim Erstellen des Ordners auf",
  "error.message.error_on_upload": "Fehler beim Hochladen der Datei",
  "error.message.folder_already_exists": "Dieser Ordner existiert bereits",
  "error.message.folder_not_found": "Ordner nicht gefunden",
  "error.message.file_not_found": "Datei nicht gefunden",
  "error.message.file_not_created":
    "Ein Fehler trat beim Erstellen der Datei auf",
  "error.message.error": "Ein Fehler ist aufgetreten",
  "error.message.file_already_exists": "Diese Datei existiert bereits",
  "error.message.entity_already_saved": "Entität hat bereits Zugang",
  "error.message.invalid_current_password": "Ungültiges aktuelles Passwort",
  "error.status.400": "Ungültige Anfrage",
  "error.status.401": "Nicht autorisiert",
  "error.status.403": "Verboten",
  "error.status.404": "Nicht gefunden",
  "error.status.500": "Interner Serverfehler",
  "error.status.502": "Serverkommunikationsfehler",
  "error.status.503": "Dienst nicht verfügbar",
  "error.status.504": "Serverkommunikation abgelaufen",
};
